import { useContext } from "react";
import { Paragraph } from "capitalrx-components-2.0/lib/typography";
import { formatPriceDisplay } from "capitalrx-utilities";
import { Divider } from "capitalrx-components-2.0/lib/general";
import cn from "classnames";
import GetTheApp from "../GetTheApp/GetTheApp";
import { ThemeSelectorContext } from "@/context/index";

import styles from "./PharmacyDetailsPriceCard.module.scss";
import { getCardName } from "@/utils/branding";

interface Props {
  price: string;
}

const PharmacyDetailsPriceCard = (props: Props): JSX.Element => {
  const { price } = props;
  const { client } = useContext(ThemeSelectorContext);
  const cardName = getCardName();

  const priceDisplayClassname = cn(
    styles.PharmacyDetailsPriceCardPrice,
    { [styles.PharmacyDetailsPriceCardWhitelabel]: !!client },
  );

  const priceHeaderClassname = cn(
    styles.PharmacyDetailsPriceCardHeader,
    { [styles.PharmacyDetailsPriceCardWhitelabel]: !!client },
  );

  const renderPrice = () => {
    let priceDisplay = "";
    if (isNaN(Number(price))) {
      priceDisplay = "Check at Pharmacy for Price.";

      return (
        <Paragraph className={priceDisplayClassname} testId="pharmacy-details-price">
          {priceDisplay}
        </Paragraph>
      );
    } else {
      priceDisplay = formatPriceDisplay(Number(price));
      return (
        <>
          <Paragraph className={priceHeaderClassname}>Estimated {cardName} Price:</Paragraph>
          <Paragraph className={priceDisplayClassname} testId="pharmacy-details-price">
            {priceDisplay}
          </Paragraph>
        </>
      );
    }
  };

  return (
    <div className={styles.PharmacyDetailsPriceCard} data-testid="pharmacy-details-price-card">
      {renderPrice()}
      <Divider />
      <GetTheApp />
    </div>
  );
};

export default PharmacyDetailsPriceCard;
